import React from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from '@material-ui/core';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import BusinessIcon from '@material-ui/icons/Business';

import { Link, NavLink, useLocation } from 'react-router-dom';

import { userProfiler, logger } from './../../utils/utils';

import {
  listMenuFrontOf,
  listMenuBackOf,
  listPermissionLevelFrontOf,
  listPermissionLevelBackOf,
  PATH_FRONTOF_MASTER,
  PATH_BACKOF_MASTER,
} from './../../routers';

function InnerSidebar({ isBackOffice, match }) {
  logger('InnerSidebar render');

  const userProfile = userProfiler.getFromLocal();
  logger({
    listMenuFrontOf,
    listMenuBackOf,
    listPermissionLevelFrontOf,
    listPermissionLevelBackOf,
    userProfile,
  });
  let fontOfCount = 0;
  let backOfCount = 0;

  // // Test menu of user.permission.level and extend to full permission
  // userProfile.permission.level = [...userProfile.permission.level, 1,2,3,8, 9]

  return (
    <div>
      {!isBackOffice && (
        <List>
          {listMenuFrontOf.map((item, index) => {
            if (
              userProfile.permission.level.some(
                (elem) => item.permissionLevel.indexOf(elem) > -1
              )
            ) {
              fontOfCount++;
              return (
                <React.Fragment key={index}>
                  <ListItem
                    component={NavLink}
                    to={item.path}
                    button
                    key={item.key}
                  >
                    <ListItemIcon>
                      <item.icon />
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItem>
                </React.Fragment>
              );
            } else {
              return null;
            }
          })}
          {fontOfCount > 0 && <Divider />}
          {/* Additinal Link */}
          {/* https://stackoverflow.com/questions/15514907/determining-whether-one-array-contains-the-contents-of-another-array-in-javascri/15514975 */}
          {userProfile.permission.level.some(
            (elem) => listPermissionLevelBackOf.indexOf(elem) > -1
          ) && (
            <React.Fragment>
              <ListItem
                component={NavLink}
                to={
                  userProfile.permission.level.some(
                    (upl) => [8, 9].indexOf(upl) > -1
                  )
                    ? `${PATH_BACKOF_MASTER}/setting/permission`
                    : PATH_BACKOF_MASTER
                }
                button
              >
                <ListItemIcon>
                  <BusinessIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText secondary="บริหารจัดการ" />
              </ListItem>
              <Divider />
            </React.Fragment>
          )}
        </List>
      )}

      {isBackOffice && (
        <List>
          {listMenuBackOf.map((item, index) => {
            if (
              userProfile.permission.level.some(
                (elem) => item.permissionLevel.indexOf(elem) > -1
              )
            ) {
              backOfCount++;
              return (
                <React.Fragment key={index}>
                  <ListItem
                    component={NavLink}
                    to={item.path}
                    button
                    key={item.key}
                  >
                    <ListItemIcon>
                      <item.icon />
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItem>
                </React.Fragment>
              );
            } else {
              return null;
            }
          })}
          {backOfCount > 0 && <Divider />}
          {/* Additinal Link */}
          {userProfile.permission.level.some(
            (elem) => listPermissionLevelFrontOf.indexOf(elem) > -1
          ) && (
            <React.Fragment>
              <ListItem component={Link} to={PATH_FRONTOF_MASTER} button>
                <ListItemIcon>
                  <HelpOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText secondary="แจ้งเหตุละเมิดข้อมูลส่วนบุคคล" />
              </ListItem>
              <Divider />
            </React.Fragment>
          )}
        </List>
      )}
    </div>
  );
}

export default React.memo(InnerSidebar);
